// extracted by mini-css-extract-plugin
module.exports = {"damage":"damage","carDamage":"carDamage","part":"part","label":"label","barContainer":"barContainer","bar":"bar","bad":"bad","broken":"broken"};